import { archives, userService } from '@saucelabs/sl-util-axios';

export const fetchFilters = (params) => (
  archives.get('/rdc/filters', { params })
);

export const getUsers = ({ limit = 99999, offset = 0 } = {}) => (
  userService.get('/v1/users/', { params: { limit, offset } })
);

export const getTeams = ({ limit = 99999, offset = 0 } = {}) => (
  userService.get('/v1/teams/', { params: { limit, offset } })
);
